import React from 'react';
import { IconV2 } from '@kizi/shared-components';
import { Div, DivProps, Anchor } from '@kizi/core-components';

interface DocumentUrlProps extends DivProps {
  href: string;
  label: string;
}

export const DocumentUrl: React.FC<DocumentUrlProps> = ({
  href,
  label,
  ...restProps
}) => (
  <Div display="flex" {...restProps}>
    <IconV2 fill="main.1" height={20} mr={2} name="document" width={20} />
    <Anchor
      color="main.1"
      href={href}
      my="auto"
      style={{ textDecoration: 'none' }}
      target="_blank"
    >
      {label}
    </Anchor>
  </Div>
);
